<template>
  <v-dialog :value="value" :max-width="esTarjeta ? 1250 : 950" persistent @input="cerrar">
    <v-card color="rgb(250, 250, 250)">
      <v-toolbar dense :height="$vuetify.breakpoint.xsOnly ? 80 : 48" :color="colorCabecera" dark flat>
        <v-toolbar-title class="solicitud-titulo">{{ titulo }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon :disabled="enviando" aria-label="Cerrar solicitud" @click="cerrar(false)"><v-icon>mdi-close-circle</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="pt-6">
        <v-select v-model="correo.de" :items="remitentesDisponibles" label="De" outlined dense :disabled="enviando" />
        <v-text-field v-model="correo.cc" label="CC" type="email" outlined dense clearable maxlength="255" :disabled="enviando" />
        <v-text-field v-model="correo.asunto" label="Asunto:" outlined dense maxlength="255" :disabled="enviando" />
        <v-textarea v-model="correo.textoMensaje" label="Texto del Correo" outlined dense rows="5" :disabled="enviando"
          persistent-hint hint="En el texto pueden aparecer etiquetas html de formato." />
        <autorizaciones-tarjeta-pasajeros v-if="esTarjeta" ref="tarjetas" :reserva-id="reserva.id" :pasajeros="pasajeros"
          :total-reserva="reserva.importe_presupuestado" :access-token="accessToken" :obtener-habitacion="obtenerHabitacion"
          :mostrar-boton-envio="false" @editar-pasajero="$emit('editar-pasajero', $event)" />
        <registros-viajeros-pasajeros v-else ref="registros" :reserva-id="reserva.id" :pasajeros="pasajeros"
          :access-token="accessToken" :obtener-habitacion="obtenerHabitacion" :enviando="enviando" @editar-pasajero="$emit('editar-pasajero', $event)" />
        <v-alert v-if="error" type="error" outlined class="mt-4" role="alert">{{ error }}</v-alert>
        <v-alert v-if="mensaje" type="success" outlined class="mt-4" role="status">{{ mensaje }}</v-alert>
        <v-row justify="end" class="mt-4"><v-btn :color="colorAccion" :loading="enviando" :disabled="enviando" @click="enviar">Enviar solicitud</v-btn></v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import AutorizacionesTarjetaPasajeros from './AutorizacionesTarjetaPasajeros.vue';
import RegistrosViajerosPasajeros from './RegistrosViajerosPasajeros.vue';
import { enviarDocumentosPasajeros } from '@/services/registrosViajeros';
import { prepararDocumentos, validarResultadoDocumentos } from '@/helpers/envioDocumentosPasajeros';

export default {
  components: { AutorizacionesTarjetaPasajeros, RegistrosViajerosPasajeros },
  props: {
    value: Boolean, tipo: { type: String, required: true, validator: value => ['tarjeta', 'registro'].includes(value) },
    reserva: { type: Object, required: true }, pasajeros: { type: Array, default: () => [] }, accessToken: { type: String, required: true },
    remitentes: { type: Array, default: () => [] },
    obtenerHabitacion: { type: Function, default: () => null }, colorCabecera: { type: String, default: '#191970' }, colorAccion: { type: String, default: '#ff9c00' },
  },
  data: () => ({ correo: { de: '', cc: '', asunto: '', textoMensaje: '' }, enviando: false, error: '', mensaje: '' }),
  computed: {
    esTarjeta() { return this.tipo === 'tarjeta'; },
    titulo() { return this.esTarjeta ? 'Solicitar autorización de tarjeta por pasajeros' : 'Solicitar registro de viajeros por pasajeros'; },
    remitentesDisponibles() { return [...new Set(this.remitentes.map(email => String(email || '').trim()).filter(Boolean))]; },
  },
  created() {
    this.correo.de = this.remitentesDisponibles[0] || '';
    this.correo.asunto = this.reserva.codigo_reserva || this.reserva.codigo || '';
  },
  methods: {
    cerrar(valor) { if (!this.enviando) this.$emit('input', valor); },
    async enviar() {
      if (this.enviando) return;
      this.error = ''; this.mensaje = '';
      const emailValido = valor => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor);
      const correo = { de: String(this.correo.de || '').trim(), asunto: String(this.correo.asunto || '').trim(), textoMensaje: this.correo.textoMensaje };
      const cc = String(this.correo.cc || '').trim();
      if (cc && !emailValido(cc)) { this.error = 'Indica un correo válido en CC o deja el campo vacío.'; return; }
      if (cc) correo.cc = cc;
      if (!emailValido(correo.de) || !correo.asunto) {
        this.error = 'Indica un remitente válido y un asunto.'; return;
      }
      const selector = this.esTarjeta ? this.$refs.tarjetas : this.$refs.registros;
      if (!selector || selector.cargando || selector.errorCarga) { this.error = 'Espera a que se carguen los pasajeros.'; return; }
      if (!selector.seleccionados.length) { this.error = 'Selecciona al menos un pasajero pendiente.'; return; }
      let filas = [];
      if (!this.esTarjeta) {
        try { filas = prepararDocumentos(selector.seleccionados, []); }
        catch (error) { this.error = error.message; return; }
      }
      this.enviando = true;
      try {
        if (this.esTarjeta) {
          if (!selector.puedeEnviar) { this.error = 'Revisa los correos, importes y depósitos de los seleccionados.'; return; }
          if (await selector.enviar(correo)) this.mensaje = 'Solicitudes de autorización enviadas correctamente.';
        } else {
          const resultado = await enviarDocumentosPasajeros(this.accessToken, this.reserva.id, filas, correo);
          validarResultadoDocumentos(resultado, filas);
          selector.aplicarResultado(resultado);
          if (resultado.envios.some(envio => !envio.enviado)) this.error = 'Hay envíos fallidos. Permanecen seleccionados para reintentar.';
          else this.mensaje = 'Solicitudes de registro enviadas correctamente.';
        }
        this.$emit('actualizado');
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.error = 'Revisa los datos: ' + Object.values(error.response.data.errors || {}).flat().join(' ');
        } else {
          if (!this.esTarjeta) await selector.cargar();
          this.error = 'No se ha podido confirmar el envío. Revisa el seguimiento y vuelve a seleccionar únicamente lo que quieras reenviar.';
          this.$emit('actualizado');
        }
      } finally { this.enviando = false; }
    },
  },
};
</script>
<style scoped>
.solicitud-titulo { font-size: 1rem; white-space: normal; }
</style>
